import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirebaseRepository } from './FirebaseRepository'

// In-memory caption cue parsed from a slide video's WebVTT file. This is no
// longer a Firestore document — the legacy slide_caption store was removed;
// cues are built from the signed vttUrl in MeetingDataFetcher.resetCaptions.
export interface FirestoreSlideCaption {
  caption: string
  startTime: number
  endTime: number
  slideId: string
  slideDeckId: string
}

const empty: FirestoreSlideCaption = Object.freeze({
  caption: '',
  startTime: 0,
  endTime: 0,
  slideId: '',
  slideDeckId: '',
})

export class SlideCaption extends ObservableModelWithDecorators<FirestoreSlideCaption> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSlideCaption>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
